import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { RegistroObservacionesProyectoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class RegistroObservacionesProyectoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getRegistroObservacionesProyectoService(): Observable<BodyListResponse<RegistroObservacionesProyectoDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesProyectoDTO>>(API_URL + '/api/v1/registroObservacionesProyecto/todos');
  }

  guardarRegistroObservacionesProyectoService(registroObservacionesProyectoDTO: RegistroObservacionesProyectoDTO): Observable<BodyResponse<RegistroObservacionesProyectoDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/registroObservacionesProyecto', registroObservacionesProyectoDTO);
  }

  getRegistroObservacionesProyectoPorproyectoService(codigo: string): Observable<BodyListResponse<RegistroObservacionesProyectoDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesProyectoDTO>>(API_URL + '/api/v1/registroObservacionesProyecto/proyecto/' + codigo);
  }


}
